import { FC } from 'react';
import { useModalContext } from 'shared/lib/modal';
import { Button, EButtonType } from 'shared/ui';
import { FooterModalStyled } from './manual-broadcast-modal-footer.styled';
import { IModalFooterProps } from './manual-broadcast-modal-footer.types';

export const ManualBroadcastModalFooter: FC<IModalFooterProps> = ({
  onSubmit,
  proceedTitile = 'Сохранить',
  canProceed,
  isLoading,
}) => {
  const { closeModal } = useModalContext();

  return (
    <FooterModalStyled>
      <Button
        onClick={() => onSubmit()}
        disabled={!canProceed}
        isLoading={isLoading}
      >
        {proceedTitile}
      </Button>
      <Button $type={EButtonType.SECONDARY} onClick={closeModal}>
        Отменить
      </Button>
    </FooterModalStyled>
  );
};
